import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './service/authentication.service';

@Injectable()
export class SuperAdminGuard implements CanActivate {
	constructor(private authService: AuthenticationService) {}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.authService.isSuperAdmin()) {
			return true;
		}

		return false;
	}
}
